'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { IconArrowRight } from '../../../svg/icons/icon-arrow-right.js';
import { formatDate, DateFormat } from '../../../util/formatters/format-date.js';
import { formatName } from '../../../util/formatters/format-name.js';
import 'date-fns';
import 'date-fns/locale';
import '../../../util/datetime/constants.js';
import '../../../util/datetime/comparators.js';
import '../../../types/order.js';
import '../../../types/category.js';
import '../../button/button.js';
import { ButtonWidth, ButtonSize, ButtonColor } from '../../button/constants.js';
import { FeaturedCoaches } from '../../featured-coaches/featured-coaches.js';
import { Popover } from '../../popover/popover.js';
import { BaseBanner, BannerColor } from '../base-banner.js';

const BaseEventBanner = ({ coaches, dateFormat = DateFormat.SHORT_MONTH_DAY, title, time, eventUrl, description, onClick, topLeft, ctaLabel = 'Enroll', }) => {
    const eventDateTime = new Date(time);
    return (jsx(BaseBanner, { color: BannerColor.PURPLE, topLeft: topLeft ? (jsx("p", { className: "flex flex-col gap-1 text-sm font-medium uppercase tracking-widest text-leland-purple sm:flex-row sm:items-center", children: topLeft })) : null, featured: coaches?.length ? (jsx(FeaturedCoaches, { coaches: coaches, featuredText: coaches.length > 1 ? (jsxs(Popover, { content: jsx("div", { className: "whitespace-pre-line", children: coaches.map((coach) => formatName(coach)).join('\n') }), children: ["Featuring", ' ', jsxs("span", { className: "underline underline-offset-2", children: [coaches.length, " top coaches"] })] })) : undefined })) : null, title: title, subtitle: `Starting ${formatDate(eventDateTime, dateFormat)}`, description: description, buttonLink: eventUrl, buttonProps: {
            buttonColor: ButtonColor.PURPLE,
            label: ctaLabel,
            RightIcon: IconArrowRight,
            size: ButtonSize.LARGE,
            width: ButtonWidth.FULL_MOBILE,
            onClick: onClick,
        } }));
};

export { BaseEventBanner };
//# sourceMappingURL=base-event-banner.js.map
